import styled from "styled-components"
import { TextDiv, TextInput } from "../../common/Text"
import { StyledButton } from "../../common/Buttons"
import DropdownInput from "../DropdownInput"
import {
  Controller,
  FieldErrors,
  FieldValues,
  useFormContext,
} from "react-hook-form"
import { toast } from "react-toastify"
import { useRequestMobileVerification } from "../../../hooks/SignupPage/useRequestMobileVerification"
import { useSetRecoilState } from "recoil"
import sessionIdState from "../../../recoil/SignupPage/sessionId/atom"
import { nanoid } from "nanoid"

interface Props {
  setIsVerificationRequested: (value: React.SetStateAction<boolean>) => void
}

const PhoneNumberInput = ({ setIsVerificationRequested }: Props) => {
  const {
    register,
    getValues,
    watch,
    control,
    formState: { errors },
  } = useFormContext()

  const { mutate } = useRequestMobileVerification()
  const setSessionId = useSetRecoilState(sessionIdState)
  const isPhoneNumberVerified = watch("isPhoneNumberVerified")

  const handleChangePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = e.target.value
      .replace(/[^0-9]/g, "")
      .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
  }

  const requestVerificationCode = () => {
    console.log(getValues("phoneNumber.mobileCarrier"))
    console.log(getValues("phoneNumber.phoneNumber"))
    if (
      getValues("phoneNumber.mobileCarrier") &&
      getValues("phoneNumber.phoneNumber")
    ) {
      const sessionId = nanoid()
      setSessionId(sessionId)
      const payload = {
        session_id: sessionId,
        phoneNumber: getValues("phoneNumber.phoneNumber"),
      }
      mutate(payload)
      setIsVerificationRequested(true)
    } else {
      toast.error("휴대전화 정보를 바르게 입력해주세요.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  }

  const error = errors.phoneNumber as FieldErrors<FieldValues>

  return (
    <RelativeDiv>
      <PhoneNumberInputBox>
        <Controller
          control={control}
          name="phoneNumber.mobileCarrier"
          render={({ field: { onChange } }) => (
            <DropdownInput
              handleName="통신사"
              selectOptions={["KT", "SKT", "LG U+", "알뜰폰"]}
              onChange={onChange}
              mode="left"
              $isError={error?.mobileCarrier ? true : false}
            />
          )}
        />

        <TextInput
          $isError={error?.phoneNumber ? true : false}
          placeholder="전화 번호"
          style={{ borderRadius: 0 }}
          {...register("phoneNumber.phoneNumber", {
            onChange: handleChangePhoneNumber,
          })}
          disabled={isPhoneNumberVerified}
        />
        <StyledButton
          $size="large"
          $bgColor={isPhoneNumberVerified ? "var(--custom-platinum)" : ""}
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            fontSize: 15,
            pointerEvents: isPhoneNumberVerified ? "none" : "inherit",
          }}
          onClick={requestVerificationCode}
          disabled={isPhoneNumberVerified}
        >
          인증
        </StyledButton>
      </PhoneNumberInputBox>
      {error?.mobileCarrier && (
        <TextDiv
          fontSize={11}
          color="var(--custom-light-red)"
          $align="start"
          style={{
            marginTop: 10,
            paddingLeft: 25,
            position: "absolute",
            top: 45,
          }}
        >
          * {error.mobileCarrier.message?.toString()}
        </TextDiv>
      )}
      {error?.phoneNumber && (
        <TextDiv
          fontSize={11}
          color="var(--custom-light-red)"
          $align="start"
          style={{
            marginTop: 10,
            paddingLeft: 25,
            position: "absolute",
            top: error?.mobileCarrier ? 65 : 45,
          }}
        >
          * {error.phoneNumber.message?.toString()}
        </TextDiv>
      )}
    </RelativeDiv>
  )
}

export default PhoneNumberInput

const RelativeDiv = styled.div`
  position: relative;
`

const PhoneNumberInputBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 50px;
  border-radius: 20px;

  > * {
    &:first-child {
      flex-basis: 90px;
      flex-shrink: 0;
    }

    &:nth-child(2) {
      flex-grow: 1;
    }

    &:last-child {
      flex-basis: 60px;
      flex-shrink: 0;
    }
  }
`
